import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  FormControl,
  TextField,
  FormLabel,
  FormControlLabel,
  Grid,
  InputAdornment,
  Stack,
  Box,
  MenuItem,
  Button,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React from "react";

import Tooltip from "../../../../components/feedback/tooltip";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { findIndexDefaultValue } from "../helper";
import DisableFieldOptions from "../options/disable-field-options";

const fileTypeList = [
  ".jpeg",
  ".jpg",
  ".png",
  ".gif",
  ".pdf",
  ".tiff",
  ".xls",
  ".xlsx",
  ".doc",
  ".docx",
  ".zip",
  ".exe",
];

export default class MultipleUploadRequired {
  static DisplayTab(props) {
    const { onChange, state, onPropertieChange, disabled } = props;

    const label = getUnitPropertie(state, "label") || "";
    const tooltip =
      getUnitPropertie(state, "tooltip") ||
      getUnitPropertie(state, "toolTip") ||
      "";

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            fullWidth
            disabled={disabled}
            onChange={onChange}
            name="id"
            variant="outlined"
            id="id"
            label="id"
            value={state.id || ""}
          />
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            disabled={disabled}
            onChange={(event) => onPropertieChange(event)}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
          />
        </Grid>

        <Grid size={12}>
          <Tooltip title={language.toolTipDescription} placement="right">
            <TextField
              fullWidth
              disabled={disabled}
              onChange={(event) => onChange(event)}
              name="description"
              variant="outlined"
              id="descricao"
              label={language.propertieDescription}
              value={state.description || ""}
            />
          </Tooltip>
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            disabled={disabled}
            onChange={onPropertieChange}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label="Tooltip"
            value={tooltip || ""}
            multiline
            rows="4"
          />
        </Grid>

      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      onToggle,
      state,
      onPropertieChange,
      addRowDefaultValue,
      handleDefaultValueChange,
      handleDefaultValueType,
      deleteDefaultValueRow,
      setObjeto, 
      onCheckChange
    } = props;
    const acceptedFiles = getUnitPropertie(state, "acceptedFiles");
    const apiUrl = getUnitPropertie(state, "apiUrl") || "";

    const [checked, setChecked] = React.useState(acceptedFiles || []);

    React.useEffect(() => {
      setChecked(acceptedFiles || []);
    }, [acceptedFiles]);

    const maxFileSize = getUnitPropertie(state, "maxFileSize");

    const index = findIndexDefaultValue(state, "documentOptions");
    const defaultobj = index >= 0 ? state.properties[index] : null;

    const handleToggle = (value) => () => {
      const currentIndex = checked.indexOf(value);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setChecked(newChecked);
      onToggle(newChecked);
    };

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            select
            onChange={(event) => handleDefaultValueType(event)}
            name="documentOptions"
            variant="outlined"
            id="documentOptions"
            label={language.datasourceType || "Tipo de fonte de dados"}
            value={defaultobj?.type || "api"}
            fullWidth
          >
            <MenuItem value="api">{language.api || "API"}</MenuItem>
            <MenuItem value="options">{language.values || "Lista local"}</MenuItem>
          </TextField>
        </Grid>

        {(!defaultobj || defaultobj?.type === "api") && (
          <Grid size={12}>
            <Tooltip
              title="URL da API para carregar a lista de opções de upload"
              placement="right"
            >
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="apiUrl"
                variant="outlined"
                id="apiUrl"
                label="URL da API"
                value={apiUrl || ""}
                placeholder="https://postgrest.dev.smartdocs.com.br/tipodocumento"
              />
            </Tooltip>
          </Grid>
        )}

        {defaultobj && defaultobj.type === "options" && (
          <>
            <Grid size={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => addRowDefaultValue("documentOptions")}
                startIcon={<AddIcon />}
              >
                {language.addNew || "Adicionar"}
              </Button>
            </Grid>
            <Grid size={12}>
              <table id="table" className="table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Tipo</th>
                    <th>Obrigatório</th>
                    <th>Variable ID</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {defaultobj &&
                    defaultobj.value &&
                    defaultobj.value.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td style={{ textAlign: "center" }}>
                            {idx + 1}
                          </td>
                          <td>
                            <input
                              name="tipo"
                              value={defaultobj.value[idx].tipo || ""}
                              onChange={(event) =>
                                handleDefaultValueChange(
                                  event,
                                  idx,
                                  "documentOptions",
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              name="obrigatorio"
                              type="checkbox"
                              checked={defaultobj.value[idx].obrigatorio || false}
                              onChange={(event) =>
                                handleDefaultValueChange(
                                  {
                                    target: {
                                      name: "obrigatorio",
                                      value: event.target.checked,
                                    },
                                  },
                                  idx,
                                  "documentOptions",
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              name="variableId"
                              value={defaultobj.value[idx].variableId || ""}
                              onChange={(event) =>
                                handleDefaultValueChange(
                                  event,
                                  idx,
                                  "documentOptions",
                                )
                              }
                            />
                          </td>
                          <td>
                            <DeleteIcon
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                deleteDefaultValueRow(idx, "documentOptions")
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Grid>
          </>
        )}

        <Grid size={12}>
          <TextField
            fullWidth
            onChange={(event) => {
              const value = event.target.value;
              event.target.value = value <= 0 ? 0 : value;
              onPropertieChange(event);
            }}
            name="maxFileSize"
            variant="outlined"
            id="maxFileSize"
            label={language.maxSizeUpload}
            value={maxFileSize || ""}
            type="number"
            InputProps={{
              endAdornment: <InputAdornment position="end">MB</InputAdornment>,
            }}
          />
        </Grid>

        <Grid size={12}>
          <FormLabel component="legend" style={{ marginTop: "2%" }}>
            {language.acceptedfiles}
          </FormLabel>
          <FormControl>
            <Stack
              spacing={2}
              direction="row"
              useFlexGap
              justifyContent="center"
              sx={{ flexWrap: "wrap" }}
            >
              {fileTypeList.map((value) => {
                const labelId = `checkbox-list-label-${value}`;

                return (
                  <Box
                    sx={{
                      width: 150,
                    }}
                    key={value}
                    role={undefined}
                    dense
                    button
                    onClick={handleToggle(value)}
                  >
                    <Tooltip title={language.toolTipHidden} placement="right">
                      <FormControlLabel
                        label={value}
                        control={
                          <Checkbox
                            edge="start"
                            checked={checked.indexOf(value) !== -1}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        }
                      />
                    </Tooltip>
                  </Box>
                );
              })}
            </Stack>
          </FormControl>
        </Grid>

        <Grid item size={12}>
          <DisableFieldOptions
            onCheckChange={onCheckChange}
            onPropertieChange={onPropertieChange}
            handleDefaultValueChange={handleDefaultValueChange}
            addRowDefaultValue={addRowDefaultValue}
            deleteDefaultValueRow={deleteDefaultValueRow}
            state={state}
            setObjeto={setObjeto}
          />
        </Grid>
      </Grid>
    );
  }
}
